/**
 * Created by rhinov15 on 05/02/2016.
 *
 * Display clickable button to change its text context
 */

import { CocosConstants } from "../../../../constants";
import { ActionStateEnum } from "../../state/actionState/ActionState";
import { PlanManager } from "../../../../cocosPlan";
import { Events, eventsManager, Listener } from "@rhinov/savane-js";

declare var cc: any;


export class LabelButtonNode extends cc.DrawNode {

    // Is the node in icon mode (icon only, no text)
    iconMode: boolean = false;
    // Is the node in label mode only (no icon, no rectangle around the text, i.e. not a buton)
    labelMode: boolean = false;
    // Size of the button
    fullLength: number = 0;
    // Is the display happening in red
    drawRed: boolean = false;

    expendX: number = 10;
    expendY: number = 7;

    constructor() {
        super()
        // Initial label content
        this.string = '';

        /*
        * Mouse even move listeners to change background color of node is hover it
        */
        this.moveListener = cc.EventListener.create({
            event: cc.EventListener.MOUSE,
            onMouseMove: function (this: LabelButtonNode, event: any) {
                if (this.isVisible()) {
                    var target = event.getCurrentTarget();
                    var dim = target.label;
                    var s = dim.getContentSize();
                    var rect = cc.rect(-this.expendX, -this.expendY, s.width + this.expendX, s.height + this.expendY);
                    rect.width += this.sprite.getContentSize().width + 10;
                    var locationInNode = dim.convertToNodeSpace(event.getLocation());
                    if (cc.rectContainsPoint(rect, locationInNode)) {
                        if (this.colorLineBackground !== this.colorHover) {
                            this.colorLineBackground = this.colorHover;
                            this.colorBack.a = 255;
                            this.label.setColor(new cc.color('#555b62'));
                            this.label.disableStroke();
                            this.redraw();
                        }
                    }
                    else {
                        if (this.colorLineBackground !== this.colorNormal) {
                            this.colorLineBackground = this.colorNormal;
                            this.label.setColor(new cc.color('#555b62'));
                            this.colorBack.a = 0;
                            // this.label.enableStroke(new cc.color(178, 174, 165),1);
                            this.redraw();
                        }
                    }
                    this.redraw();
                }
            }.bind(this)
        });

        this.addListeners();

        // Init of initiale colors for the node
        this.colorLineBackground = new cc.color(178, 174, 165);
        this.colorHover = new cc.color(178, 174, 164);
        this.colorNormal = new cc.color(178, 174, 165);
        this.colorBack = new cc.color('#F5D231');
        this.colorBack.a = 0;

        // Initiale node zoom (get it from scroll Window)
        this.zoom = PlanManager.getInstance().getZoomScale();

        this.showSpriteSmart = false;
    }
    
    setZoom(value: number) {
        this.zoom = value;

        this.clear();
        this.redraw();
    }

    /**
     * init the label button node
     * @param
     * @param
     */
    init(): boolean {
        this.setAnchorPoint(0, 0);

        // Init cocos node
        if (super.init()) {
            var fontSize = 15;
            var labelSize = new cc.size(0, 19);

            this.label = new cc.LabelTTF('', 'Roboto-Light', fontSize, labelSize, cc.TEXT_ALIGNMENT_CENTER, cc.TEXT_ALIGNMENT_CENTER);
            // this.label.enableStroke(new cc.color(178, 174, 165),1);
            this.label.setName('buttonLabel');
            this.label.setAnchorPoint(new cc.p(0, 0.5));
            this.label.setColor(new cc.color('#555b62'));
            // Gray pen if the label is already named
            this.sprite = new cc.Sprite();
            this.sprite.initWithSpriteFrameName('plan/buttonEditPicto.png');
            this.sprite.setAnchorPoint(new cc.p(0, 0.5));

            // Load red pen icon if the node isn't already named
            this.spriteRed = new cc.Sprite();
            this.spriteRed.initWithSpriteFrameName('plan/buttonRedEditPicto.png');
            this.spriteRed.setAnchorPoint(new cc.p(0, 0.5));

            // // Load smart icon if the node contains smart data
            this.spriteSmart = new cc.Sprite();
            this.spriteSmart.setTexture(CocosConstants.resourcesBasePath + '/resources/wand.png');
            this.spriteSmart.setAnchorPoint(new cc.p(0, 0.5));

            // Gray pen if the label is already named
            this.sprite = new cc.Sprite();
            this.sprite.initWithSpriteFrameName('plan/buttonEditPicto.png');
            this.sprite.setAnchorPoint(new cc.p(0, 0.5));


            // Add node childs, text and sprites
            this.addChild(this.label);
            this.addChild(this.sprite);
            this.addChild(this.spriteRed);
            this.addChild(this.spriteSmart);

            // Compute initial sull size
            this.fullLength = this.label.getContentSize().width + 10 + this.sprite.getContentSize().width;

            return true;
        }
        return false;
    }

    /**
     * Update value of the text label displayed in the middle of the LabelButton
     * @param label text
     * @param
     */
    setString(value: string) {
        // Only set the string if different than previously
        if (value !== this.string) {
            // Store the string
            this.string = value;
            // And if the string says to rename the room, then we display the label with red color
            if (this.string === 'Renommer la pièce') {
                this.drawRed = true;
            }
            else {
                this.drawRed = false;
            }
            // Finally redraw the label button
            this.redraw();
        }
    }

    /**
     * Redraw node to process new values
     */
    redraw() {
        // Warning color value (medium red)
        var colorWarning = new cc.color('#800000');
        // Copy label mode and icon mode into local variables so we can change them without altering the original values
        var labelMode = this.labelMode;
        var iconMode = this.iconMode;

        // Clear node content
        this.clear();

        // Set text color depending on content (do we have to display the button in red or not)
        if (this.drawRed) {
            this.label.setColor(colorWarning);
        }
        else {
            this.label.setColor(new cc.color('#555b62'));
        }

        if (PlanManager.getInstance().state.isDecorationState() || PlanManager.getInstance().state.isVisualiseState()) {
            if (this.string === 'Renommer la pièce') {
                this.label.setVisible(false);
            }
            else {
                this.label.setVisible(true);
            }
            labelMode = true;
            iconMode = false;
        }
        else {
            if (PlanManager.getInstance().getAction() === ActionStateEnum.RoomsValidation) {
                if (this.string === 'Renommer la pièce') {
                    iconMode = true;
                    labelMode = false;
                    this.label.setVisible(false);
                }
                else {
                    iconMode = false;
                    labelMode = true;
                    this.label.setVisible(true);
                }
            }
            else {
                if (!iconMode) {
                    this.label.setVisible(true);
                }
                labelMode = false;
            }
        }

        var clampedInvZoom = 1.0 / this.zoom;

        // If not icon mode or label mode then display the node text
        if (!iconMode || labelMode) {
            this.label.setString(this.string);
        }
        else {
            // Don't display text
            this.label.setString('');
        }

        var w = labelMode ? 0 : (iconMode ? 0 : 10) + this.sprite.getContentSize().width;

        this.fullLength = this.label.getContentSize().width + w;
        this.fullLength *= clampedInvZoom;

        this.label.setPositionX(- this.fullLength / 2);
        this.label.setScale(clampedInvZoom);

        if (!labelMode) {
            if (this.drawRed) {
                this.sprite.setVisible(false);
                this.spriteRed.setVisible(true);
            }
            else {
                this.sprite.setVisible(true);
                this.spriteRed.setVisible(false);
            }

            this.sprite.setPositionX(-this.fullLength / 2 + ((this.iconMode ? 0 : 10) + this.label.getContentSize().width) * clampedInvZoom);
            this.spriteRed.setPositionX(-this.fullLength / 2 + ((this.iconMode ? 0 : 10) + this.label.getContentSize().width) * clampedInvZoom);
            this.sprite.setScale(clampedInvZoom);
            this.spriteRed.setScale(clampedInvZoom);
            this.spriteSmart.setVisible(false);
        }
        else {
            this.sprite.setVisible(false);
            this.spriteRed.setVisible(false);
            if(this.showSpriteSmart)
            {
                this.spriteSmart.setPositionX(-this.fullLength / 2 + ((this.iconMode ? 0 : 10) + this.label.getContentSize().width) * clampedInvZoom);
                this.spriteSmart.setScale(clampedInvZoom);
                this.spriteSmart.setVisible(true);
            } else {
                this.spriteSmart.setVisible( false );
            }

        }

       

        // If not label mode
        if (!labelMode) {
            var startPoint = new cc.p(-(this.fullLength * 0.5 + this.expendX * clampedInvZoom), -(this.label.getContentSize().height * 0.5 + this.expendY) * clampedInvZoom);
            var endPoint = new cc.p((this.fullLength * 0.5 + this.expendX * clampedInvZoom), (this.label.getContentSize().height * 0.5 + this.expendY) * clampedInvZoom);

            // Draw a rectangle around the label to create a button
            if (this.drawRed) {
                this.drawRect(startPoint, endPoint, this.colorBack, 2.0 / this.zoom, colorWarning);
            }
            else {
                this.drawRect(startPoint, endPoint, this.colorBack, 2.0 / this.zoom, this.colorLineBackground);
            }
        }
    }

    /**
     * Flip labels
     * @param value
     */
    setFlipped(value: any) {
        this.label.setFlippedY(value);
        this.label.setFlippedX(value);
    }

    /**
     * Add listener
     */
    addListeners() {
        cc.eventManager.addListener(this.moveListener, this);
    }

    /**
     * Remove all attached listener
     */
    removeListeners() {
        // Remove scroll listener
        eventsManager.instance.removeListener(this.scrollListener);
        // Remove the state listener
        eventsManager.instance.removeListener(this.stateListener);
        // Remove the mouse move listener
        cc.eventManager.removeListener(this.moveListener);
    }

    /**
     * Returns the midele points of the text label (generally to know if it fits in an area)
     */
    getMiddlePoints() {
        this.label.setString(this.string);

        var clampedInvZoom = 1.0 / this.zoom;
        var w = this.labelMode ? 0 : (this.iconMode ? 0 : 10) + this.sprite.getContentSize().width;
        this.fullLength = this.label.getContentSize().width + w;
        this.fullLength *= clampedInvZoom;
        var startPoint = new cc.p(this.getPositionX() - (this.fullLength * 0.5 + this.expendX * clampedInvZoom), this.getPositionY() - (this.label.getContentSize().height * 0.5 + this.expendY) * clampedInvZoom);
        var endPoint = new cc.p(this.getPositionX() + (this.fullLength * 0.5 + this.expendX * clampedInvZoom), this.getPositionY() + (this.label.getContentSize().height * 0.5 + this.expendY) * clampedInvZoom);
        var points = {
            a: startPoint,
            b: endPoint
        };
        if (this.iconMode) {
            this.label.setString('');
            this.fullLength = this.label.getContentSize().width + (this.iconMode ? 0 : 10) + this.sprite.getContentSize().width;
            this.fullLength *= clampedInvZoom;
        }

        return points;
    }

    /**
     * Checks if a mouse click is inside the label
     */
    isClickIn(cursorPos: any) {
        // If only label and no icon, then click has no effect
        if (this.labelMode) {
            return (false);
        }

        // Only check if the node and label are visible
        if (this.isVisible() && this.label.isVisible()) {
            // Get bounding box of label node
            var rect = this.label.getBoundingBoxToWorld();

            // Add the sprite size + margin
            rect.width += 10 + this.sprite.getContentSize().width;
            // Check is the click is inside the bounding box
            if (cc.rectContainsPoint(rect, cursorPos)) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    /**
     * Toggle true/false to icon mode (i.e. don't display the label, only display the icon)
     */
    toggleIconMode(bool: boolean) {
        if (this.iconMode != bool) {
            this.iconMode = bool;
            this.redraw();
        }
    }

    editionStart() {
        this.colorBack.a = 0;
        this.colorLineBackground = this.colorHover;
        this.redraw();
    }

    editionEnd() {
        this.colorBack.a = 0;
        this.colorLineBackground = this.colorNormal;
    }

    // CLass creation
    onEnter() {
        // Call super class creation/init
        super.onEnter();

        // Create scroll listener attached to zoom function
        this.scrollListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, function (this: LabelButtonNode, event: any) {
            this.setZoom(event.getUserData());
        }.bind(this));

        // Create a state listener so if the state changes, the label will be redrawn
        this.stateListener = new Listener(this.redraw.bind(this));
        eventsManager.instance.addListenerObject(Events.PLAN_STATE_CHANGED, this.stateListener);
    }

    // Object destruction
    onExit() {
        // Destruct super class
        super.onExit();
        // Remive current class listeners
        this.removeListeners();
    }

    toggleSmartIcon (bool: boolean) {
        this.showSpriteSmart = bool;
        this.redraw();
    }
}